import avatar1 from "../../assets/images/testimonials/avatar1.png";
import avatar2 from "../../assets/images/testimonials/avatar2.png";
import avatar3 from "../../assets/images/testimonials/avatar3.png";
import avatar4 from "../../assets/images/testimonials/avatar4.png";


export const testimonialsData = [
    {
        id: 1,
        name: "Etty Kusuma",
        position: "Owner Mitra Tani Klaten",
        src: avatar1,
        review: "As the owner of Mitra Tani Klaten, I am very satisfied with the result of our website, mitrataniklaten.com. The design is professional and has greatly helped in expanding our business reach."
    },
    {
        id: 2,
        name: "Salsabila Nadia Kusuma",
        position: "Owner & Founder Miliikody",
        src: avatar2,
        review: "The website miliikody.vercel.app truly reflects my vision as the founder of Miliikody. I am very grateful to the team for creating such a functional and visually appealing site."
    },
    {
        id: 3,
        name: "Anggaras",
        position: "Head of Event",
        src: avatar3,
        review: "The Logo P2K Harmoni UAD 2023 represents a forward-thinking financial approach. We help people understand the best ways to plan their finances."
    },
    {
        id: 4,
        name: "Destinas",
        position: "Head of Division Ekonomi Wirausaha",
        src: avatar4,
        review: "The Logo Ekorium (Ekonomi Emporium) signifies the importance of strategic financial decisions. We provide guidance on the best saving and investing practices."
    }
];
